import '.co{font-size:1.125rem;}.ssr-plugin'
import '.f5{line-height:1.75rem;}.ssr-plugin'
import '.c4{text-decoration:none;}.ssr-plugin'
import '.e7{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="co f5"
    >
      {translations.privacySubtitle}{' '}
      <a className="c4 e7"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="c4 e7"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
